import { makeStyles } from '@material-ui/core'

const variants = {
  primary: {
    base: 'var(--color-primary-500)',
    text: 'var(--color-primary-700)'
  },
  success: {
    base: 'var(--color-success-500)',
    text: 'var(--color-success-700)'
  },
  warning: {
    base: 'var(--color-warning-500)',
    text: 'var(--color-warning-700)'
  },
  danger: {
    base: 'var(--color-danger-500)',
    text: 'var(--color-danger-700)'
  },
  info: {
    base: 'var(--color-info-500)',
    text: 'var(--color-info-700)'
  },
  neutral: {
    base: 'var(--color-neutral-500)',
    text: 'var(--color-neutral-700)'
  },
  ai: {
    base: 'var(--color-ai-500)',
    text: 'var(--color-ai-700)'
  }
}

const sizes = (theme) => ({
  xs: {
    padding: '0px 6px',
    fontSize: theme.typography.fontSizes.xs,
    lineHeight: '16px',
    minHeight: '16px'
  },
  sm: {
    padding: '1px 8px',
    fontSize: theme.typography.fontSizes.xs,
    lineHeight: '18px',
    minHeight: '20px'
  },
  md: {
    padding: '2px 10px',
    fontSize: theme.typography.fontSizes.sm,
    lineHeight: '20px',
    minHeight: '24px'
  }
})

const buildVariantStyle = ({ variant, opacity }) => {
  const v = variants[variant]
  return {
    backgroundColor: `color-mix(in srgb, ${v.base} ${Math.round(opacity * 100)}%, transparent)`,
    border: `1.5px solid ${v.base}`,
    color: v.text
  }
}

export const useBadgeStyles = makeStyles((theme) => ({
  badge: ({ variant, size, opacity }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    borderRadius: 'var(--border-radius-round)',
    fontWeight: theme.typography.weights.semibold,
    whiteSpace: 'nowrap',
    ...buildVariantStyle({ variant, opacity }),
    ...sizes(theme)[size]
  })
}))
